import { render, staticRenderFns } from "./UserSettingsContactUpdate.vue?vue&type=template&id=c48b2546&scoped=true&"
import script from "./UserSettingsContactUpdate.vue?vue&type=script&lang=js&"
export * from "./UserSettingsContactUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48b2546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c48b2546')) {
      api.createRecord('c48b2546', component.options)
    } else {
      api.reload('c48b2546', component.options)
    }
    module.hot.accept("./UserSettingsContactUpdate.vue?vue&type=template&id=c48b2546&scoped=true&", function () {
      api.rerender('c48b2546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/base/UserSettings/UserSettingsContact/UserSettingsContactUpdate.vue"
export default component.exports